module.exports = __webpack_public_path__ + "img/syslog-config.e2ebf918.png";